import { getPathAdAccountId } from './index'

export const setAuthorizationHeader = config => {
  const accessToken = sessionStorage.getItem('accessToken')
  if (accessToken) {
    config.headers.set('Authorization', `Bearer ${accessToken}`)
  }
  const adAccountId = getPathAdAccountId()
  if (adAccountId) {
    config.headers.set('x-bizgw-asset-type', 'AD_ACCOUNT')
    config.headers.set('x-bizgw-asset-id', adAccountId)
    config.headers.set('adAccountId', adAccountId)
  }
  return config
}
